import React, { Component } from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { ACCEPTABLE_USE_POLICY } from "../../../assets/legal/AcceptableUsePolicy";
import { TERMS_OF_SERVICE } from "../../../assets/legal/TermsOfService";

export default class TermsOfService extends Component {
    render() {
        return (
            <div style={{backgroundColor: '#DADADA'}}>
                <Grid container justifyContent="center">
                    <Grid item xs={11} sm={10} md={9}>
                    <Paper style={{ position: 'relative', marginTop: 50, padding: 50, marginBottom: 50}}>
                    <div
                      style={{
                        fontSize: '14px',
                        lineHeight: '1.6',
                      }}
                    >
                      <style>
                        {`
                          .policy-content h1 { font-size: 24px; margin-top: 1.5em; }
                          .policy-content h2 { font-size: 18px; margin-top: 1.25em; }
                          .policy-content h3 { font-size: 16px; margin-top: 1em; }
                          .policy-content h4 { font-size: 15px; margin-top: 0.75em; }
                          .policy-content ul { padding-left: 1.25em; }
                          .policy-content p { margin-bottom: 1em; }
                        `}
                      </style>
                      <div
                        className="policy-content"
                        dangerouslySetInnerHTML={{ __html: TERMS_OF_SERVICE.markup }}
                      />
                    </div>
                    </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}
